// NOTIF-INST-01 · «Activar notificaciones en este dispositivo». El permiso se pide SÓLO con este toque.
import { useEffect, useState } from "react";
import { BellRing, BellOff, Bell } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import * as push from "@/lib/push/webpush";

const TEXTO = {
  activada: "Notificaciones activadas",
  denegada: "Notificaciones bloqueadas en este dispositivo",
  no_disponible: "Notificaciones no disponibles aquí",
  requiere_activacion: "Vuelve a activar las notificaciones",
  inactiva: "Activar notificaciones en este dispositivo",
};

export function BotonPushIpad({ compacto = false }) {
  const { user } = useAuth();
  const [est, setEst] = useState("inactiva");
  const [msg, setMsg] = useState("");
  const [ocupado, setOcupado] = useState(false);

  // Reconcilia con el servidor cada vez que cambia la sesión: un vínculo de otra sesión no cuenta.
  useEffect(() => {
    if (!user?.id) return;
    push.estado(user.id).then((r) => { setEst(r.estado); if (r.mensaje) setMsg(r.mensaje); });
  }, [user?.id]);

  const alternar = async () => {
    setOcupado(true);
    try {
      const r = est === "activada" ? await push.desactivar() : await push.activar(user?.id);
      setEst(r.estado);
      setMsg(r.mensaje || "");
    } catch {
      setMsg("No se pudieron activar las notificaciones en este dispositivo.");
    } finally {
      setOcupado(false);
    }
  };

  const Icono = est === "activada" ? BellRing : est === "denegada" || est === "no_disponible" ? BellOff : Bell;
  const bloqueado = est === "denegada" || est === "no_disponible";

  if (compacto) {
    return (
      <button type="button" data-testid="push-ipad-toggle-compacto" onClick={alternar}
        disabled={ocupado || bloqueado} title={TEXTO[est]} aria-label={TEXTO[est]}
        className={`flex h-9 w-9 items-center justify-center rounded-xl transition-colors ${
          est === "activada" ? "text-[#0C7A88] hover:bg-slate-50 dark:text-[#5FD8E2] dark:hover:bg-slate-700"
            : bloqueado ? "text-slate-300 dark:text-slate-600"
              : "text-slate-500 hover:bg-slate-50 hover:text-[#012472] dark:text-slate-200 dark:hover:bg-slate-700"}`}>
        <Icono strokeWidth={1.8} className="h-4 w-4" />
      </button>
    );
  }

  return (
    <div className="px-1">
      <button type="button" data-testid="push-ipad-toggle" onClick={alternar}
        disabled={ocupado || bloqueado}
        className={`flex w-full items-center gap-3 rounded-xl px-4 py-3 text-left text-sm font-medium transition-colors ${
          est === "activada"
            ? "bg-[#0C7A88]/10 text-[#0C7A88] dark:bg-[#5FD8E2]/15 dark:text-[#5FD8E2]"
            : bloqueado
              ? "text-slate-400 dark:text-slate-500"
              : "text-slate-600 hover:bg-slate-100 dark:text-slate-200 dark:hover:bg-slate-700"}`}>
        <Icono strokeWidth={1.6} className="h-5 w-5 shrink-0" />
        <span data-testid="push-ipad-estado">{ocupado ? "Un momento…" : TEXTO[est]}</span>
      </button>
      {msg && <p data-testid="push-ipad-mensaje" className="px-4 pt-1 text-xs text-slate-500 dark:text-slate-400">{msg}</p>}
      {bloqueado && (
        <p data-testid="push-ipad-ayuda" className="px-4 pt-1 text-xs text-slate-500 dark:text-slate-400">
          {est === "denegada"
            ? "Vuelve a permitirlas en Ajustes del iPad › Notificaciones › Galarya."
            : "En iPad, añade Galarya a la pantalla de inicio y ábrela desde ahí."}
        </p>
      )}
    </div>
  );
}
